<template>
  <div class="table-responsive">
    <BOverlay
      :show="loadingData"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      class="w-100"
      rounded="sm"
    >
      <table class="table table-hover">
        <TableHeaderExpeditionFee />
        <tbody v-if="true">
          <tr
            v-for="(item, idx) in listServices"
            :key="`data-${idx}`"
          >
            <td>
              <div
                v-b-toggle="`collapse${idx}`"
                class="d-flex justify-between"
              >
                <div
                  class="d-flex gap-10"
                >
                  <div class="w-14 bg-[#FFECE9] px-[7px] py-[3px] rounded-pill">
                    <img
                      :src="item.image_logo"
                      alt=""
                    >
                  </div>
                  <div class="align-self-center">
                    {{ item.shipping_name }}
                  </div>
                </div>
                <span class="when-open k-arrow-down-1 align-content-center" />
                <span class="when-closed k-arrow-right-2 align-content-center" />
              </div>
              <b-collapse
                :id="'collapse' + `${idx}`"
                class="mt-2"
              >
                <li
                  v-for="(services, index) in item.services"
                  :key="index"
                  class="mb-[10px]"
                >
                  {{ services.service_name }}
                </li>
              </b-collapse>
            </td>
            <td class="align-content-end text-center">
              <b-collapse
                :id="'collapse' + `${idx}`"
              >
                <div
                  v-for="(services, index) in item.services"
                  :key="index"
                  class="mb-[10px]"
                >
                  {{ services.cashback_from }}%
                </div>
              </b-collapse>
            </td>
            <td class="align-content-end text-center">
              <b-collapse
                :id="'collapse' + `${idx}`"
              >
                <div
                  v-for="(services, index) in item.services"
                  :key="index"
                  class="mb-[10px]"
                >
                  {{ services.cod_fee_from }}%
                </div>
              </b-collapse>
            </td>
            <td class="align-content-end text-center">
              <b-collapse
                :id="'collapse' + `${idx}`"
              >
                <div
                  v-for="(services, index) in item.services"
                  :key="index"
                  class="mb-[10px]"
                >
                  {{ services.cashback_to }}%
                </div>
              </b-collapse>
            </td>
            <td class="align-content-end text-center">
              <b-collapse
                :id="'collapse' + `${idx}`"
              >
                <div
                  v-for="(services, index) in item.services"
                  :key="index"
                  class="mb-[10px]"
                >
                  {{ services.cashback_to_juragan }}%
                </div>
              </b-collapse>
            </td>
            <td class="align-content-end text-center">
              <b-collapse
                :id="'collapse' + `${idx}`"
              >
                <div
                  v-for="(services, index) in item.services"
                  :key="index"
                  class="mb-[10px]"
                >
                  {{ services.cashback_to_saudagar }}%
                </div>
              </b-collapse>
            </td>
            <td class="align-content-end text-center">
              <div class="w-full self-start p-[10px]">
                <b-button
                  variant="light"
                  size="sm"
                  @click="changeExpeditionFee(item)"
                >
                  <span class="k-edit text-xl" />
                </b-button>
              </div>
              <b-collapse
                :id="'collapse' + `${idx}`"
              >
                <div
                  v-for="(services, index) in item.services"
                  :key="index"
                  class="mb-[10px]"
                >
                  {{ services.cod_fee_to }}%
                </div>
              </b-collapse>
            </td>
          </tr>
        </tbody>
        <tbody
          v-else
          class="my-2"
          style="position: absolute; justify-self: anchor-center;"
        >
          <tr>
            Tidak Ada Data Untuk Ditampilkan
          </tr>
        </tbody>
      </table>
    </BOverlay>
  </div>
</template>

<script>
import TableHeaderExpeditionFee from './TableHeaderExpeditionFee.vue'

export default {
  components: { TableHeaderExpeditionFee },
  data() {
    return {
      loadingData: true,
      listServices: [],
    }
  },
  mounted() {
    this.getListServices()
  },
  methods: {
    getListServices() {
      const params = {
        source: 'komship',
      }
      const url = '/komship/api/v1/admin/shipment/configure/cost'

      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.listServices = data
          this.loadingData = false
        })
        .catch(err => {
          this.loadingData = false
          this.$toast_error({ message: 'Tidak mendapatkan list ekspedisi' })
        })
    },
    changeExpeditionFee(expedition) {
      this.$router.push({ name: 'edit-biaya-ekspedisi', params: expedition })
    },
  },
}
</script>

<style>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
